import React from 'react';
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { prettyId, miniDescription } from '../../selectors/stompunkt'


export default ({ id, stompunkt, onClick, onRemove }) => (
	<ListItem button onClick={onClick}>
		<ListItemText primary={prettyId(stompunkt)} secondary={miniDescription(stompunkt)} />
		<ListItemSecondaryAction>
            <IconButton onClick={onRemove}>
                <CloseIcon />
            </IconButton>
        </ListItemSecondaryAction>
	</ListItem>
)



// WEBPACK FOOTER //
// ./src/components/Selection/SelectionItem.js